// import React,{useEffect} from "react";
import "../../assets/css/Technologies.css";
import FrontOne from "../../assets/image/Technologies/tech-logo-1.png";
import FrontTwo from "../../assets/image/Technologies/tech-logo-2.png";
import FrontThree from "../../assets/image/Technologies/tech-logo-3.png";
import FrontFour from "../../assets/image/Technologies/tech-logo-4.png";
import BackOne from "../../assets/image/Technologies/back-logo-1.png";
import BackTwo from "../../assets/image/Technologies/back-logo-2.png";
import BackThree from "../../assets/image/Technologies/back-logo-3.png";
import BackFour from "../../assets/image/Technologies/back-logo-4.png";
import BackFive from "../../assets/image/Technologies/back-logo-5.png";
import BackSix from "../../assets/image/Technologies/back-logo-6.png";
import MobileOne from "../../assets/image/Technologies/mobile-logo-1.png";
import MobileTwo from "../../assets/image/Technologies/mobile-logo-2.png";
import MobileThree from "../../assets/image/Technologies/mobile-logo-3.png";
import MobileFour from "../../assets/image/Technologies/mobile-logo-4.png";
import DevopsOne from "../../assets/image/Technologies/devops-logo-1.png";
import DevopsTwo from "../../assets/image/Technologies/devops-logo-2.png";
import DevopsThree from "../../assets/image/Technologies/devops-logo-3.png";
import DevopsFour from "../../assets/image/Technologies/devops-logo-4.png";
import DevopsFive from "../../assets/image/Technologies/devops-logo-5.png";
import DevopsSix from "../../assets/image/Technologies/devops-logo-6.png";
import GameOne from "../../assets/image/Technologies/game-logo-1.png";
import GameTwo from "../../assets/image/Technologies/game-logo-2.png";
import GameThree from "../../assets/image/Technologies/game-logo-3.png";
import GameFour from "../../assets/image/Technologies/game-logo-4.png";
import GameFive from "../../assets/image/Technologies/game-logo-5.png";
import GameSix from "../../assets/image/Technologies/game-logo-6.png";
import DataOne from "../../assets/image/Technologies/data-logo-1.png";
import DataTwo from "../../assets/image/Technologies/data-logo-2.png";
import DataThree from "../../assets/image/Technologies/data-logo-3.png";
import DataFour from "../../assets/image/Technologies/data-logo-4.png";
import IotOne from "../../assets/image/Technologies/iot-logo-1.png";
import IotTwo from "../../assets/image/Technologies/iot-logo-2.png";
import IotThree from "../../assets/image/Technologies/iot-logo-3.png";
import IotFour from "../../assets/image/Technologies/iot-logo-4.png";
import QAOne from "../../assets/image/Technologies/qa-logo-1.jfif";
import QATwo from "../../assets/image/Technologies/qa-logo-2.png";
import { Container, Row, Col, Card } from "react-bootstrap";
import { FaUsers, FaHeadset, FaMoneyBillAlt } from "react-icons/fa";
import TechOne from "../../assets/image/Technologies/tech-1.jpg";
import CountUp from "react-countup";
import Footer from "../Footer/Footer";
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import data from "../../Meta/Meta_ApiUrl"
import dyi from '../../assets/image/Home/dyi.jpg'
import pixhawk from '../../assets/image/Home/pixhawk.png'
import ardupilot from '../../assets/image/Home/ardupilot.webp'
import px4 from '../../assets/image/Home/px4.png'
import thermal from '../../assets/image/Home/thermal.webp'
import scikitlearn from '../../assets/image/Home/scikitlearn.png'
import nlp from '../../assets/image/Home/nlp.png'
import mqtt from '../../assets/image/Home/mqtt.png'
import sensor from '../../assets/image/Home/sensor.jpg'
import embeddedc from '../../assets/image/Home/embeddedc.jpg'
import nodemcu from '../../assets/image/Home/nodemcu.webp'
import ros from '../../assets/image/Home/ros.png'
import automation from '../../assets/image/Home/automation.jpg'
import embeddedsystems from '../../assets/image/Home/embeddedsystems.jpg'
import controlsystems from '../../assets/image/Home/controlsystems.jpg'
import prototyping from '../../assets/image/Home/prototyping.jpg'
import mechanicalDesgin from '../../assets/image/Home/mechanicalDesgin.jpg'
import aws from '../../assets/image/Home/aws.png'


const Technologies = () => {
  const [meta, setMeta] = useState({});

  useEffect(() => {
    const Gamedevelopment = data[0]?.services_page_Technologies;

    if (Gamedevelopment) {
      setMeta(Gamedevelopment);
    }
  }, [])

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to top-left corner
  }, []);


  const navigate = useNavigate();
  const front = [
    {
      src: FrontOne,
      name: "React Js",
      link: "#",
    },
    {
      src: FrontTwo,
      name: "Angular JS",
      link: "#",
    },
    {
      src: FrontThree,
      name: "Javascript",
      link: "#",
    },
    {
      src: FrontFour,
      name: "HTML 5",
      link: "#",
    },
  ];

  const back = [
    {
      src: BackOne,
      name: "JAVA",
      link: "#",
    },
    {
      src: BackTwo,
      name: "PYTHON",
      link: "#",
    },
    {
      src: BackThree,
      name: "SPRING BOOT MVC",
      link: "#",
    },
    {
      src: BackFour,
      name: "SPRING BOOT",
      link: "#",
    },
    {
      src: BackFive,
      name: "PHP",
      link: "#",
    },
    {
      src: BackSix,
      name: "NODE JS",
      link: "#",
    },
  ];

  const mobile = [
    {
      src: MobileOne,
      name: "SWIFT",
      link: "#",
    },
    {
      src: BackOne,
      name: "JAVA",
      link: "#",
    },
    {
      src: MobileTwo,
      name: "Android",
      link: "#",
    },
    {
      src: MobileThree,
      name: "Kotlin",
      link: "#",
    },
    {
      src: MobileFour,
      name: "Flutter",
      link: "#",
    },
  ];

  const devops = [
    {
      src: DevopsOne,
      name: "Jenkins",
      link: "#",
    },
    {
      src: DevopsTwo,
      name: "Docker",
      link: "#",
    },
    {
      src: DevopsThree,
      name: "Kubernetes",
      link: "#",
    },
    {
      src: DevopsFour,
      name: "AWS",
      link: "#",
    },
    {
      src: DevopsFive,
      name: "Microservice",
      link: "#",
    },
    {
      src: DevopsSix,
      name: "Git/Github",
      link: "#",
    },
  ];

  const game = [
    {
      src: GameOne,
      name: "Unity",
      link: "#",
    },
    {
      src: GameTwo,
      name: "SmartFoxServer",
      link: "#",
    },
    {
      src: GameThree,
      name: "Photon Engine",
      link: "#",
    },
    {
      src: GameFour,
      name: "Cocos2d-x",
      link: "#",
    },
    {
      src: GameFive,
      name: "Cocos Creator",
      link: "#",
    },
    {
      src: GameSix,
      name: "Unreal Engine",
      link: "#",
    },
  ];

  const data = [
    {
      src: DataOne,
      name: "MySQL",
      link: "#",
    },
    {
      src: DataTwo,
      name: "PostgreSQL",
      link: "#",
    },
    {
      src: DataThree,
      name: "MongoDB",
      link: "#",
    },
    {
      src: DataFour,
      name: "Oracle Database",
      link: "#",
    },
  ];

  const iot = [
    {
      src: BackTwo,
      name: "python",
      link: "#",
    },
    {
      src: IotOne,
      name: "C program",
      link: "#",
    },
    {
      src: IotTwo,
      name: "C++",
      link: "#",
    },
    {
      src: IotThree,
      name: "QT C++",
      link: "#",
    },
    {
      src: IotFour,
      name: "Lua",
      link: "#",
    },
  ];

  const qa = [
    {
      src: QAOne,
      name: "Selenium",
      link: "#",
    },
    {
      src: QATwo,
      name: "Appium",
      link: "#",
    },
  ];

  const drone = [
    { src: dyi, name: "DJI" },
    { src: pixhawk, name: "Pixhawk" },
    { src: ardupilot, name: "ArduPilot" },
    { src: px4, name: "PX4" },
    // { src: , name: "RTK GPS" },
    { src: thermal, name: "Thermal Imaging" },
  ];

  const ai = [
    { src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tensorflow/tensorflow-original.svg", name: "TensorFlow" },
    { src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/pytorch/pytorch-original.svg", name: "PyTorch" },
    { src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/opencv/opencv-original.svg", name: "OpenCV" },
    { src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg", name: "Python" },
    { src: automation, name: "Machine Learning" },
    { src: automation, name: "Computer Vision" },
  ];

  const robotics = [
    { src: ros, name: "ROS" },
    { src: automation, name: "Automation" },
    { src: embeddedsystems, name: "Embedded Systems" },
    { src: controlsystems, name: "Control Systems" },
    { src: prototyping, name: "Prototyping" },
    { src: mechanicalDesgin, name: "Mechanical Design" },
  ];
  return (
    <HelmetProvider>
      <div>
        <Helmet>
          <title>{meta?.title || "Services-Technologies - SHIV NEXTGEN TECHNOLOGIES PRIVATE LIMITED"}</title>
          <meta
            name="description"
            content={
              meta?.meta?.meta1?.content ||
              "Our curriculum."
            }
          />
        </Helmet>
        {/* Banner */}
        <div
          className="position-relative min-vh-50 tech-bg d-flex align-items-center justify-content-center bg-dark text-white"
          style={{ overflowX: "hidden", width: "100%" }}
        >
          <div className="container position-relative px-3 px-md-4">
            <div className="row align-items-center">
              <div className="col-12 tech-content">
                <nav
                  aria-label="breadcrumb"
                  className="mb-3 mb-md-4"

                >
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a
                        href="/"
                        className="text-white fw-bold text-decoration-nfont-para"
                      >
                        Home
                      </a>
                    </li>
                    <li className="breadcrumb-item fw-bold" aria-current="page">
                      Technologies
                    </li>
                  </ol>
                </nav>
                <h3
                  className="display-5 display-md-5 fw-bold mb-3 text-md-start"
                >
                  Technologies
                </h3>
              </div>
            </div>
          </div>
        </div>


        {/* Section-1 */}
        <div className="container my-5">
          <div className="row align-items-center">
            <div className="col-lg-6 order-lg-1 mb-4 mb-lg-0">
              <div className="image-container top-left">
                <img
                  src={TechOne}
                  alt="IT Solutions"
                  className="img-fluid rounded-3"
                // style={{
                //   width:"700px",
                //   height:"700px",
                //   objectFit: "cover",
                // }}
                />
              </div>
            </div>

            {/* Content Column */}
            <div className="col-lg-6 order-lg-2">
              <div className="ms-lg-5 ms-md-5">
                {/* Heading and description */}
                <h3 className="fw-bold display-6 font-black mb-3">
                  Exclusive technology to <br />
                  provide IT solutions
                </h3>
                <p className="font-para mb-3">
                  Each demo built with Teba will look different. You can customize
                  almost anything in the appearance of your website with only a
                  few clicks. Each demo built with Teba will look different.
                </p>

                {/* Stats section */}
                <div className="d-flex mb-2">
                  <div className="pe-4 border-end">
                    <h3 className="fw-bold font-black">
                      <CountUp end={1800} duration={6} separator="," />+
                    </h3>
                    <p className="text-muted">Happy Clients</p>
                  </div>
                  <div className="ps-4">
                    <h3 className="fw-bold font-black">
                      <CountUp end={620} duration={6} separator="," />+
                    </h3>
                    <p className="text-muted">Finished Projects</p>
                  </div>
                </div>

                {/* Button */}
                <button
                  className="btn btn-red text-white fw-semibold px-4 py-2"
                  onClick={() => navigate('/about')}
                >
                  More About Us
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Drone */}
        <div className="container-fluid">
          <div className="container py-4">
            <div className="row align-items-center">

              {/* Left Content */}
              <div className="col-md-6 mb-lg-4 mb-md-0 order-1 order-md-2">
                <h3 className="fw-bold font-black display-5">
                  Drone <span className="font-red">Technology</span>
                </h3>
                <p className="font-para me-md-5">
                  We deliver advanced drone solutions for aerial intelligence,
                  inspection, mapping, and automation. Our drone technologies help
                  industries improve efficiency, reduce risks, and gain real-time
                  actionable insights through high-precision data collection.
                </p>
              </div>

              {/* Right Slider */}
              <div className="col-md-6 position-relative overflow-hidden order-2 order-md-1">
                <div className="d-flex flex-nowrap slider-track">
                  {[...drone, ...drone].map((logo, index) => (
                    <div key={index} className="text-center mx-3 slider-item">
                      <img src={logo.src} alt={logo.name} className="img-fluid mb-2"
                        style={{ width: "200px", height: "200px", objectFit: "contain" }}
                      />
                      <div className="fw-bold text-uppercase font-black">
                        {logo.name}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Robotics*/}
        <div className="container-fluid bg-light">
          <div className="container py-4">
            <div className="row align-items-center">

              {/* Content */}
              <div className="col-md-6">
                <h3 className="fw-bold font-black display-5">
                  Robotics <span className="font-red">Engineering</span>
                </h3>
                <p className="font-para me-md-5">
                  We design and develop intelligent robotic systems for automation,
                  industrial applications, and research. Our solutions focus on precision,
                  efficiency, and real-world usability.
                </p>
              </div>

              {/* Slider */}
              <div className="col-md-6 position-relative overflow-hidden">
                <div className="d-flex flex-nowrap slider-track">
                  {[...robotics, ...robotics].map((logo, index) => (
                    <div key={index} className="text-center mx-3 slider-item">
                      <img src={logo.src} alt={logo.name} className="img-fluid mb-2"
                        style={{ width: "200px", height: "200px", objectFit: "contain" }}
                      />
                      <div className="fw-bold text-uppercase font-black">
                        {logo.name}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* AI */}
        <div className="container py-4">
          <div className="row align-items-center">


            {/* Slider Left */}
            <div className="col-md-6 position-relative overflow-hidden">
              <div className="d-flex flex-nowrap slider-track-1">
                {[...ai, ...ai].map((logo, index) => (
                  <div key={index} className="text-center mx-3 slider-item-1">
                    <img src={logo.src} alt={logo.name} className="img-fluid mb-2"
                      style={{ width: "200px", height: "200px", objectFit: "contain" }}
                    />
                    <div className="fw-bold text-uppercase font-black">
                      {logo.name}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            {/* Content Right */}
            <div className="col-md-6">
              <h3 className="fw-bold font-black display-5 ms-md-5">
                Artificial <span className="font-red">Intelligence</span>
              </h3>
              <p className="font-para ms-md-5">
                Our AI solutions enable businesses to automate processes, analyze data,
                and make intelligent decisions. From machine learning to computer vision,
                we build systems that enhance efficiency and unlock new possibilities.
              </p>
            </div>

          </div>
        </div>

        {/* IOT Development right*/}
        <div className="container-fluid bg-light">
          <div className="container py-4 bg-light">
            <div className="row align-items-center">
              {/* Left Column */}
              <div className="col-md-6 mb-lg-4 mb-md-0">
                <h3 className="fw-bold font-black display-5">
                  IOT <span className="font-red">Development</span>
                </h3>
                <p className="font-para me-md-5 me-lg-5">
                  <p className="font-para me-md-5 me-lg-5">
                    We build smart IoT systems that connect devices, collect real-time data,
                    and automate operations. Our solutions help businesses monitor, control,
                    and optimize processes through intelligent, connected ecosystems.
                  </p>
                </p>
              </div>

              {/* Right Column - Scrolling front */}
              <div className="col-md-6 position-relative overflow-hidden">
                <div className="d-flex flex-nowrap slider-track">
                  {[...iot, ...iot].map((logo, index) => (
                    <a
                      key={index}
                      href={logo.link}
                      className="text-center text-decoration-none mx-3 slider-item"
                    >
                      <img
                        src={logo.src}
                        alt={logo.name}
                        className="img-fluid mb-2"
                        style={{
                          width: "200px",
                          height: "200px",
                          objectFit: "contain",
                        }}
                      />
                      <div className="fw-bold text-uppercase font-black">
                        {logo.name}
                      </div>
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Front-End right*/}
        <div className="container-fulid bg-light">
          <div className="container py-4">
            <div className="row align-items-center">
              {/* Right Column - Scrolling front */}
              <div className="col-md-6 position-relative overflow-hidden order-2 order-md-1">
                <div className="d-flex flex-nowrap slider-track">
                  {[...front, ...front].map((logo, index) => (
                    <a
                      key={index}
                      href={logo.link}
                      className="text-center text-decoration-none mx-3 slider-item"
                    >
                      <img
                        src={logo.src}
                        alt={logo.name}
                        className="img-fluid mb-2"
                        style={{
                          width: "200px",
                          height: "200px",
                          objectFit: "contain",
                          background: "transparent",
                        }}
                      />
                      <div className="fw-bold text-uppercase font-black ">
                        {logo.name}
                      </div>
                    </a>
                  ))}
                </div>
              </div>
              {/* Left Column */}
              <div className="col-md-6 mb-lg-4 mb-md-0 order-2 order-md-1">
                <h3 className="fw-bold font-black display-5">
                  Web Front <span className="font-red">End</span>
                </h3>
                <p className="font-para me-md-5 me-lg-5">
                  Our web front-end development services redefine digital
                  experiences by seamlessly integrating creativity and
                  functionality. Leveraging cutting-edge technologies and industry
                  best practices, our team develops visually stunning and
                  user-friendly interfaces that mesmerize audiences and enhance
                  user engagement.
                </p>
                <p className="font-para me-md-5 me-lg-5">
                  From responsive design to intuitive navigation, we prioritize
                  user experience to ensure that our client’s websites are
                  complete and exceed expectations. Trust us to transform your
                  ideas into captivating web experiences.
                </p>
              </div>


            </div>
          </div>
        </div>

        {/* Back-End left*/}
        <div className="container py-4">
          <div className="row align-items-center">
            {/* Right Column - Text (Top on mobile, Left on desktop) */}
            <div className="col-md-6 mb-lg-4 mb-md-0">
              <h3 className="fw-bold font-black display-5 ms-md-5 ms-lg-5">
                Back <span className="font-red">End</span>
              </h3>
              <p className="font-para ms-md-5 ms-lg-5">
                Back-end development services play a crucial role in powering the
                functionality of websites and applications, serving as the engine
                that drives the seamless operation of digital platforms. From
                managing databases and server-side logic to ensuring data security
                and scalability, our back-end developers work diligently to create
                robust and efficient systems. With a dedicated team of seasoned
                developers, we leverage cutting-edge technologies to ensure
                optimal performance, security, and flexibility, positioning
                ourselves as the go-to partner for businesses seeking a reliable
                and efficient back-end infrastructure.
              </p>
            </div>

            {/* Left Column - Slider (Bottom on mobile, Right on desktop) */}
            <div className="col-md-6 position-relative overflow-hidden">
              <div className="d-flex flex-nowrap slider-track-1">
                {[...back, ...back].map((logo, index) => (
                  <a
                    key={index}
                    href={logo.link}
                    className="text-center text-decoration-none mx-3 slider-item-1"
                  >
                    <img
                      src={logo.src}
                      alt={logo.name}
                      className="img-fluid mb-2"
                      style={{
                        width: "200px",
                        height: "200px",
                        objectFit: "contain",
                      }}
                    />
                    <div className="fw-bold text-uppercase font-black">
                      {logo.name}
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Technology right*/}
        <div className="container-fluid bg-light">
          <div className="container py-4 bg-light">
            <div className="row align-items-center">


              {/* Right Column - Scrolling front */}
              <div className="col-md-6 position-relative overflow-hidden order-2 order-md-1">
                <div className="d-flex flex-nowrap slider-track">
                  {[...mobile, ...mobile].map((logo, index) => (
                    <a
                      key={index}
                      href={logo.link}
                      className="text-center text-decoration-none mx-3 slider-item"
                    >
                      <img
                        src={logo.src}
                        alt={logo.name}
                        className="img-fluid mb-2"
                        style={{
                          width: "200px",
                          height: "200px",
                          objectFit: "contain",
                        }}
                      />
                      <div className="fw-bold text-uppercase font-black">
                        {logo.name}
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Left Column */}
              <div className="col-md-6 mb-lg-4 mb-md-0 order-2 order-md-1">
                <h3 className="fw-bold font-black me-md-5 me-lg-5 display-5">
                  Mobile <span className="font-red">Technology</span>
                </h3>
                <p className="font-para me-md-5 me-lg-5">
                  Mobile technology app development services play a pivotal role
                  in the ever-evolving digital landscape, enabling businesses to
                  reach their audiences seamlessly through smartphones and
                  tablets. Our skilled mobile app developers leverage cutting-edge
                  technologies to create user-friendly interfaces and robust
                  functionalities, ensuring a competitive edge in the app market.
                  With a focus on user experience and functionality, our mobile
                  technology app development services empower your businesses to
                  engage and connect with your target audience in the mobile-first
                  era.
                </p>
              </div>

            </div>
          </div>
        </div>

        {/* DevOps Technology */}
        <div className="container py-4">
          <div className="row align-items-center">

            {/* Right Column - Scrolling front */}
            <div className="col-md-6 mb-lg-4 mb-md-0">
              <h3 className="fw-bold font-black display-5 ms-md-5 ms-lg-5">
                DevOps <span className="font-red">Technology</span>
              </h3>
              <p className="font-para ms-md-5 ms-lg-5">
                DevOps is a methodology that aims to improve the collaboration
                between software developers and IT operations professionals. Its
                vision is also to enhance the efficiency of software delivery and
                infrastructure management. With a commitment to streamlining
                workflows, improving collaboration, and automating processes, our
                DevOps Solutions empower organizations to achieve continuous
                integration and delivery. Leveraging cutting-edge technologies and
                a team of seasoned experts, we ensure seamless integration, rapid
                deployment, and efficient management of software development
                lifecycles, ultimately accelerating innovation and improving
                overall business agility.
              </p>
            </div>

            {/* Left Column */}
            <div className="col-md-6 position-relative overflow-hidden">
              <div className="d-flex flex-nowrap slider-track-1">
                {[...devops, ...devops].map((logo, index) => (
                  <a
                    key={index}
                    href={logo.link}
                    className="text-center text-decoration-none mx-3 slider-item-1"
                  >
                    <img
                      src={logo.src}
                      alt={logo.name}
                      className="img-fluid mb-2"
                      style={{
                        width: "200px",
                        height: "200px",
                        objectFit: "contain",
                      }}
                    />
                    <div className="fw-bold text-uppercase font-black">
                      {logo.name}
                    </div>
                  </a>
                ))}
              </div>
            </div>

          </div>
        </div>

        {/* Game Development right*/}
        {/* <div className="container-fulid bg-light">
          <div className="container py-4">
            <div className="row align-items-center">
              <div className="col-md-6 mb-lg-4 mb-md-0 order-2 order-md-1">
                <h3 className="fw-bold font-black display-5">
                  Game <span className="font-red">Development</span>
                </h3>
                <p className="font-para me-md-5 me-lg-5">
                  KPIS is a cutting-edge game development company that stands at
                  the forefront of the gaming industry. Renowned for our
                  innovative approach and commitment to quality, we offer a
                  progressive and end-to-end game development service that
                  fulfills all modern-day game app requirements from the player's
                  perspective. With a talented team of developers, designers, and
                  creatives, the company pushes the boundaries of technology to
                  create memorable games that resonate with players worldwide. Our
                  skilled developers, well-versed in state-of-the-art game engines
                  and technologies, create immersive gaming adventures that
                  connect with players.
                </p>
              </div>

              <div className="col-md-6 position-relative overflow-hidden order-2 order-md-1">
                <div className="d-flex flex-nowrap slider-track">
                  {[...game, ...game].map((logo, index) => (
                    <a
                      key={index}
                      href={logo.link}
                      className="text-center text-decoration-none mx-3 slider-item"
                    >
                      <img
                        src={logo.src}
                        alt={logo.name}
                        className="img-fluid mb-2"
                        style={{
                          width: "200px",
                          height: "200px",
                          objectFit: "contain",
                          background: "transparent",
                        }}
                      />
                      <div className="fw-bold text-uppercase font-black ">
                        {logo.name}
                      </div>
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div> */}

        {/* Database left*/}
        <div className="container py-4">
          <div className="row align-items-center">
            {/* Left Column */}
            <div className="col-md-6 position-relative overflow-hidden order-2 order-md-1">
              <div className="d-flex flex-nowrap slider-track-1">
                {[...data, ...data].map((logo, index) => (
                  <a
                    key={index}
                    href={logo.link}
                    className="text-center text-decoration-none mx-3 slider-item-1"
                  >
                    <img
                      src={logo.src}
                      alt={logo.name}
                      className="img-fluid mb-2"
                      style={{
                        width: "200px",
                        height: "200px",
                        objectFit: "contain",
                      }}
                    />
                    <div className="fw-bold text-uppercase font-black">
                      {logo.name}
                    </div>
                  </a>
                ))}
              </div>
            </div>

            {/* Right Column - Scrolling front */}
            <div className="col-md-6 mb-lg-4 mb-md-0 order-1 order-md-2">
              <h3 className="fw-bold font-black display-5 ms-md-5 ms-lg-5">
                Database <span className="font-red">Technology</span>
              </h3>
              <p className="font-para ms-md-5 ms-lg-5">
                Database Development is a well-established process of creating a
                user interface data application. This application is operated in
                to modify, download, and upload data from any centralized database
                access. With a team of skilled developers and data architects, we
                offer tailored services ranging from database design and
                optimization to migration and maintenance. Our commitment to
                cutting-edge technologies ensures clients benefit from scalable,
                efficient, and secure database systems, empowering organizations
                to harness the full potential of their data for strategic
                decision-making and improved operational efficiency.
              </p>
            </div>
          </div>
        </div>



        {/* QA (Quality Assurance) */}
        {/* <div className="container py-4">
          <div className="row align-items-center">
            <div className="col-md-6 position-relative overflow-hidden order-2 order-md-1">
              <div className="d-flex flex-nowrap slider-track-1">
                {[...qa, ...qa].map((logo, index) => (
                  <a
                    key={index}
                    href={logo.link}
                    className="text-center text-decoration-none mx-3 slider-item-1"
                  >
                    <img
                      src={logo.src}
                      alt={logo.name}
                      className="img-fluid mb-2"
                      style={{
                        width: "200px",
                        height: "200px",
                        objectFit: "contain",
                      }}
                    />
                    <div className="fw-bold text-uppercase font-black">
                      {logo.name}
                    </div>
                  </a>
                ))}
              </div>
            </div>

            <div className="col-md-6 mb-lg-4 mb-md-0 order-1 order-md-2">
              <h3 className="fw-bold font-black display-5 ms-md-5 ms-lg-5">
                Quality <span className="font-red"> Assurance</span>
              </h3>
              <p className="font-para ms-md-5 ms-lg-5">
                Quality assurance focuses on administrative and procedural
                activities that are implemented in a quality system to meet the
                requirements and purpose of a product, service, or activity. QA
                includes systematic measurement, standard comparison, process
                monitoring, and drawing feedback to prevent errors. Our seasoned
                team of QA professionals barely considers software applications,
                websites, and systems to identify and rectify any anomalies,
                guaranteeing a seamless user experience. With accuracy and
                efficiency, our QA services are instrumental in enhancing overall
                product quality and reliability, instilling confidence in clients
                and end-users alike.
              </p>
            </div>
          </div>
        </div> */}
        <Footer />
      </div>
    </HelmetProvider>
  );
};

export default Technologies;
